import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'

import 'amfe-flexible';
import 'lib-flexible'

import "./plugins/index";

import "./assets/css/common.less"


Vue.config.productionTip = false

import Vconsole from 'vconsole'
// 仅在非生产环境（开发/测试）启用 vConsole
if (process.env.ENV !== 'production') {
  const vConsole = new Vconsole();
  window.vConsole = vConsole;
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
